"use client";

import { useEffect } from "react";
import { pushToDataLayer } from "@/lib/gtm";

type StylistProfileTrackerProps = {
  stylistName?: string | null;
};

const StylistProfileTracker = ({ stylistName }: StylistProfileTrackerProps) => {
  useEffect(() => {
    const normalizedName = stylistName?.trim();
    if (!normalizedName) return;

    pushToDataLayer("stylist_profile_view", {
      stylist_name: normalizedName,
    });

    if (process.env.NODE_ENV !== "production") {
      console.debug("[GTM] stylist_profile_view dispatched", {
        stylist_name: normalizedName,
      });
    }
  }, [stylistName]);

  return null;
};

export default StylistProfileTracker;
